import React, { useState, useRef, useEffect, useCallback } from "react";
import SideBar from "../../components/bars/SideBar";
import styles from "../../style/Pages/ChatPage.module.css";
import ChatLayout from "../../layouts/ChatLayout";
import ChatHeader from "../../components/chat/ChatHeader";
import ChatView from "../../components/chat/ChatView/ChatView";
import ChatInput from "../../components/chat/ChatInput/ChatInput";
import DmsPannel from "../../components/bars/DmsPannel";
import {
  getSelectedDms,
  getUserDetails,
  storeSelectedDms,
} from "../../utils/auth";
import useChatDMS from "../../hooks/useChatDMS";
import NoConvFound from "../../components/ui/NoDataFound/NoConvFound";
import { useDmsPanel } from "../../hooks/useDms";
import PersonQuickView from "./PopUp/PersonQuickView";
import ViewGroupPopUp from "./PopUp/ViewGroupPopUp";
import websocketservice from "../../services/websocket";
import { fetchSelectedPeople } from "../../services/commonServices";
import { useInfiniteMessagesDms } from "../../hooks/useInfiniteMessages";
import { useInView } from "react-intersection-observer";
import ChatForward from "../../components/chat/ChatForword";
import DeletionMsgConfirm from "../../components/ui/Warning/MessageDeletion";

const DMs = () => {
  const chatViewRef = useRef(null);
  const [height, setHeight] = useState(40);
  const [refreshCount, setRefreshCount] = useState(0);
  const [refreshChat, setRefreshChat] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [skipLoader, setSkipLoader] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const { directMessages, loading } = useDmsPanel(
    skipLoader,
    refreshCount,
    searchTerm
  );
  const selectedUser = getSelectedDms();
  const selectedUserRef = useRef(selectedUser);
  const userDetails = getUserDetails() || {};
  const [showGroupPopup, setShowGroupPopup] = useState(false);
  const [showPersonPopUp, setShowPersonPopUp] = useState(false);
  const [showForword, setShowForword] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const userName = selectedUser?.name || "";
  const BASE_URL = process.env.REACT_APP_API_URL;
  const groupId = selectedUser?.group_id;
  const userId = selectedUser?.user_id;
  const onlineStatus = selectedUser?.online;
  const userImage = selectedUser?.emp_pic;

  const loadingRef = useRef(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const scrollPositionRef = useRef(0);
  const previousMessagesLengthRef = useRef(0);
  const isScrollingProgrammaticallyRef = useRef(false);
  const initialLoadCompleteRef = useRef(false);
  const currentChatRef = useRef(selectedUser?.chat_unique);

  const [selectedMessageDel, setSelectedMessageDel] = useState(null);
  const [showDelete, setShowDelete] = useState(false);
  const [pinQuery, setPinQuery] = useState("");

  const {
    text,
    setText,
    uploadedFiles,
    inputRef,
    handleFileChange,
    handleRemoveFile,
    handleSend,
    handleChange,
    clearSendingMessage,
    reactions,
    typing,
    insertMentionUser,
    clearRecivingMessage,
    sendingmessage: chatSendingMessage,
    recivingMessage: recivedMessageSocket,
    pendingMessages,
    setPendingMessages,
    setUploadedFiles,
    setTyping,
    forwardMessage,
    deleteMessage,
    deletedMessages: hookDeletedMessages,
    clearDeletedMessages,
    pinMessage,
    unpinMessage,
    pinUpdates,
  } = useChatDMS(refreshChat);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading: loadingConv,
    refetch: refetchMessages,
  } = useInfiniteMessagesDms(debouncedSearchQuery, pinQuery);

  useEffect(() => {
    if (selectedUser?.chat_unique) {
      refetchMessages();
    }
  }, [selectedUser?.chat_unique, refetchMessages]);

  const handleSearch = useCallback(
    (query) => {
      setSearchQuery(query);
      clearSendingMessage();
      clearRecivingMessage();
    },
    [clearRecivingMessage, clearSendingMessage]
  );

  useEffect(() => {
    setSearchQuery("");
    setDebouncedSearchQuery("");
  }, [selectedUser?.chat_unique]);

  const handleWorkspaceUpdate = () => {
    setRefreshCount((prev) => prev + 1);
    refetchMessages();
    setPendingMessages(false);
    setText([]);
    setUploadedFiles([]);
    clearDeletedMessages();
    refetchMessages();
  };
  let query = "";
  if (selectedUser) {
    if (selectedUser.is_group_chat === "0") {
      query = `register_id=${selectedUser.user_id}`;
    } else if (selectedUser.is_group_chat === "1") {
      query = `group_id=${selectedUser.group_id}`;
    } else if (selectedUser.is_group_chat === "channel") {
      query = `channel_id=${selectedUser.id}`;
    }
  }

  useEffect(() => {
    selectedUserRef.current = selectedUser;
  }, [selectedUser]);

  useEffect(() => {
    const updateSelectedUserFromApi = async () => {
      if (!selectedUserRef.current) return;

      try {
        let updatedData = null;
        const res = await fetchSelectedPeople(`?${query}`);

        if (selectedUserRef.current.is_group_chat === "channel") {
          updatedData = {
            ...selectedUserRef.current,
            channel_name: res?.channel_details[0]?.channel_name,
            allow_access:
              res?.identify_active_deactive.channel_details[0]?.allow_access,
            channel_manager:
              res?.identify_active_deactive.channel_details[0]?.channel_manager,
          };
        } else if (selectedUserRef.current.is_group_chat === "1") {
          updatedData = {
            ...selectedUserRef.current,
            name: res?.identify_active_deactive.group_details[0]?.group_name,
            emp_pic: res?.identify_active_deactive.group_details[0]?.group_icon,
            status:
              res?.identify_active_deactive?.group_details[0]?.group_status,
          };
        } else if (selectedUserRef.current.is_group_chat === "0") {
          updatedData = {
            ...selectedUserRef.current,
            name: res?.identify_active_deactive?.employee_details[0]?.name,
            emp_pic:
              res?.identify_active_deactive?.employee_details[0]?.emp_pic,
            status:
              res?.identify_active_deactive?.employee_details[0]?.active_status,
          };
        }

        if (
          updatedData &&
          JSON.stringify(updatedData) !==
            JSON.stringify(selectedUserRef.current)
        ) {
          storeSelectedDms(updatedData);
        }
      } catch (error) {}
    };

    if (query) updateSelectedUserFromApi();
  }, [query]);

  const renderChatInput = () => {
    if (selectedUser?.status === "1") {
      return (
        <div className={styles.DisabledInput}>
          You are viewing the archives of a deactivated account
        </div>
      );
    }

    if (selectedUser?.type === "channel") {
      if (selectedUser.allow_access === "only_manager") {
        const isManager = selectedUser.channel_manager?.includes(
          userDetails.id
        );
        if (!isManager) {
          return (
            <div className={styles.DisabledInput}>
              Only managers can send messages in this channel
            </div>
          );
        }
      }
    }

    return (
      <ChatInput
        text={text}
        setText={setText}
        uploadedFiles={uploadedFiles}
        handleFileChange={handleFileChange}
        handleRemoveFile={handleRemoveFile}
        handleSend={handleSend}
        handleChange={handleChange}
        inputRef={inputRef}
        onHeightChange={setHeight}
        insertMentionUser={insertMentionUser}
      />
    );
  };
  const getMessageTimestamp = useCallback((date, time) => {
    try {
      const [timePart, period] = time.split(" ");
      let [hours, minutes, seconds = 0] = timePart.split(":").map(Number);

      // Convert to 24-hour format
      if (period === "PM" && hours < 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;

      const dateObj = new Date(date);
      dateObj.setHours(hours, minutes, seconds, 0);
      return dateObj.getTime();
    } catch (error) {
      return new Date().getTime();
    }
  }, []);

  const handleDeleteClick = useCallback((messageId, chatUniqueId) => {
    setSelectedMessageDel({ messageId, chatUniqueId });
    setShowDelete(true);
  }, []);

  const handleCloseDelete = useCallback(() => {
    setShowDelete(false);
    setSelectedMessageDel(null);
  }, []);

  const handleDeleteMessage = useCallback(
    (messageId, chatUniqueId) => {
      deleteMessage(messageId, chatUniqueId);
      refetchMessages();
    },
    [refetchMessages, deleteMessage]
  );

  const handleForwardClick = useCallback((messageId, chatUniqueId) => {
    setSelectedMessage({ messageId, chatUniqueId });
    setShowForword(true);
  }, []);

  const handleCloseForward = useCallback(() => {
    setShowForword(false);
    setSelectedMessage(null);
  }, []);

  const handleForward = useCallback(
    (data, selectedUser) => {
      storeSelectedDms(selectedUser, selectedUser);

      forwardMessage(data, selectedUser);
      handleCloseForward();
    },
    [forwardMessage, handleCloseForward]
  );
  const allMessages = React.useMemo(() => {
    if (!data?.pages) return [];

    return data.pages.flatMap((page) =>
      page.messages.map((msg) => ({
        isReceived: true,
        userName: msg.name,
        text: msg.message,
        time: msg.time,
        date: msg.date,
        user_id: msg.user_id,
        id: msg.message_id,
        reactions:
          msg.reactions?.map((r) => ({
            ...r,
            react_emoji:
              typeof r.react_emoji === "string"
                ? JSON.parse(r.react_emoji)
                : r.react_emoji,
          })) || [],
        file: msg.file_url,
        avatar: `${BASE_URL}${msg.emp_pic}`,
        source: "api",
        timestamp: getMessageTimestamp(msg.date, msg.time),
        is_forward: msg?.is_forward,
        is_pinned: msg?.is_pinned,
      }))
    );
  }, [data, BASE_URL, getMessageTimestamp]);
  const combinedMessages = React.useMemo(() => {
    const socketRecvMessages = (recivedMessageSocket || []).map((msg) => ({
      isReceived: true,
      userName: msg.name,
      text: msg.message,
      time: msg.time,
      date: msg.date,
      user_id: msg.user_id,
      id: msg.message_id,
      reactions:
        msg.reactions?.map((r) => ({
          ...r,
          react_emoji:
            typeof r.react_emoji === "string"
              ? JSON.parse(r.react_emoji)
              : r.react_emoji,
        })) || [],
      file: msg.file_url,
      avatar: `${BASE_URL}/${msg.emp_pic}`,
      source: "socket_receive",
      timestamp: getMessageTimestamp(msg.date, msg.time),
      is_forward: msg?.is_forward,
      is_pinned: msg?.is_pinned,
    }));
    const socketSendMessages = (chatSendingMessage || []).map((msg) => ({
      isReceived: false,
      userName: userDetails.name,
      text: msg.message,
      time: msg.time,
      date: msg.date,
      user_id: msg.user_id,
      file: msg.file_url,
      id: msg.message_id,
      reactions:
        msg.reactions?.map((r) => ({
          ...r,
          react_emoji:
            typeof r.react_emoji === "string"
              ? JSON.parse(r.react_emoji)
              : r.react_emoji,
        })) || [],
      avatar: `${BASE_URL}${msg.emp_pic}`,
      source: "socket_send",
      timestamp: getMessageTimestamp(msg.date, msg.time),
      is_forward: msg?.is_forward,
      is_pinned: msg?.is_pinned,
    }));

    const allCombined = [
      ...(allMessages || []),
      ...socketSendMessages,
      ...socketRecvMessages,
    ];

    const messagesWithPinUpdates = allCombined.map((message) => {
      const pinUpdate = pinUpdates.find(
        (pin) =>
          pin.message_id === message.id &&
          pin.chat_unique_id === selectedUser?.chat_unique
      );

      if (pinUpdate) {
        return {
          ...message,
          is_pinned: pinUpdate.is_pinned,
        };
      }
      return message;
    });

    const uniqueMessages = messagesWithPinUpdates.reduce((acc, current) => {
      const existing = acc.find((msg) => msg.id === current.id);
      if (!existing) {
        acc.push(current);
      } else {
        if (current.source.startsWith("socket")) {
          const index = acc.indexOf(existing);
          acc[index] = current;
        }
      }
      return acc;
    }, []);
    const filteredMessages = uniqueMessages.filter(
      (message) =>
        !hookDeletedMessages.some(
          (deleted) =>
            deleted.messageId === message.id &&
            deleted.chatUniqueId === selectedUser?.chat_unique
        )
    );

    return filteredMessages.sort((a, b) => a.timestamp - b.timestamp);
  }, [
    allMessages,
    hookDeletedMessages,
    chatSendingMessage,
    recivedMessageSocket,
    BASE_URL,
    userDetails.name,
    getMessageTimestamp,
    selectedUser?.chat_unique,
    pinUpdates,
  ]);

  const handlePinClick = useCallback(
    (messageId, chatUniqueId, isCurrentlyPinned) => {
      if (isCurrentlyPinned === "pinned") {
        unpinMessage(messageId, chatUniqueId);
      } else {
        pinMessage(messageId, chatUniqueId);
      }
    },
    [pinMessage, unpinMessage]
  );
  const handleHeaderPinClick = useCallback(() => {
    setPinQuery((prev) => (prev === "pin_message" ? "" : "pin_message"));
  }, []);
  useEffect(() => {
    if (selectedUser?.chat_unique) {
      refetchMessages();
    }
  }, [pinQuery, selectedUser?.chat_unique, refetchMessages]);

  const isConversationPinned = false;
  useEffect(() => {
    if (selectedUser?.chat_unique !== currentChatRef.current) {
      clearSendingMessage();
      clearRecivingMessage();
      currentChatRef.current = selectedUser?.chat_unique;
    }
  }, [selectedUser?.chat_unique, clearSendingMessage, clearRecivingMessage]);

  useEffect(() => {
    let heartbeat;

    const startHeartbeat = () => {
      heartbeat = setInterval(() => {
        setSkipLoader(true);
        setRefreshCount((prev) => prev + 1);
      }, 20000);
    };

    const stopHeartbeat = () => {
      if (heartbeat) clearInterval(heartbeat);
    };

    if (document.visibilityState === "visible") {
      startHeartbeat();
    }

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        startHeartbeat();
      } else {
        stopHeartbeat();
      }
    });

    return () => {
      stopHeartbeat();
      document.removeEventListener("visibilitychange", () => {});
    };
  }, []);

  const onSelectConversation = (data) => {
    websocketservice.disconnect();
    storeSelectedDms(data?.data);
    setRefreshCount((prev) => prev + 1);
    setRefreshChat((prev) => prev + 1);
    setPendingMessages(false);
    setText([]);
    setUploadedFiles([]);
    clearSendingMessage();
    clearRecivingMessage();
    setTyping("");
    refetchMessages();
    clearDeletedMessages();
  };

  useEffect(() => {
    const handleFocus = () => {
      setSkipLoader(true);
      setRefreshCount((prev) => prev + 1);
      setTyping("");
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, [clearRecivingMessage, clearSendingMessage, setTyping]);

  const handleHeaderClick = () => {
    if (selectedUser?.is_group_chat === "1") {
      setShowGroupPopup(true);
    } else {
      setShowPersonPopUp(true);
    }
  };
  const handleUpdated = () => {
    setRefreshCount((prev) => prev + 1);
  };

  const storeScrollPosition = useCallback(() => {
    if (
      chatViewRef.current &&
      !isScrollingProgrammaticallyRef.current &&
      initialLoadCompleteRef.current
    ) {
      const chatContainer = chatViewRef.current;
      scrollPositionRef.current =
        chatContainer.scrollHeight - chatContainer.scrollTop;
      previousMessagesLengthRef.current = combinedMessages.length;
    }
  }, [combinedMessages.length]);

  const restoreScrollPosition = useCallback(() => {
    if (
      chatViewRef.current &&
      scrollPositionRef.current > 0 &&
      initialLoadCompleteRef.current
    ) {
      isScrollingProgrammaticallyRef.current = true;
      const chatContainer = chatViewRef.current;
      const newScrollHeight = chatContainer.scrollHeight;
      const newScrollTop = newScrollHeight - scrollPositionRef.current;

      chatContainer.scrollTop = newScrollTop;

      setTimeout(() => {
        isScrollingProgrammaticallyRef.current = false;
      }, 100);
    }
  }, []);

  const scrollToBottom = useCallback(() => {
    if (chatViewRef.current && combinedMessages.length > 0) {
      isScrollingProgrammaticallyRef.current = true;
      const chatContainer = chatViewRef.current;

      setTimeout(() => {
        chatContainer.scrollTop = chatContainer.scrollHeight;

        setTimeout(() => {
          isScrollingProgrammaticallyRef.current = false;
          initialLoadCompleteRef.current = true;
        }, 100);
      }, 100);
    }
  }, [combinedMessages.length]);

  useEffect(() => {
    const chatContainer = chatViewRef?.current;
    if (!chatContainer) return;

    const handleScroll = () => {
      if (
        !isScrollingProgrammaticallyRef.current &&
        initialLoadCompleteRef.current
      ) {
        storeScrollPosition();
      }
    };

    chatContainer.addEventListener("scroll", handleScroll);
    return () => chatContainer.removeEventListener("scroll", handleScroll);
  }, [storeScrollPosition]);

  useEffect(() => {
    if (combinedMessages.length > 0) {
      if (isInitialLoad || !initialLoadCompleteRef.current) {
        scrollToBottom();
        setIsInitialLoad(false);
      } else if (combinedMessages.length > previousMessagesLengthRef.current) {
        restoreScrollPosition();
        previousMessagesLengthRef.current = combinedMessages.length;
      } else if (combinedMessages.length < previousMessagesLengthRef.current) {
        previousMessagesLengthRef.current = combinedMessages.length;
        scrollPositionRef.current = 0;
        initialLoadCompleteRef.current = false;
        setIsInitialLoad(true);
      }
    }
  }, [
    combinedMessages.length,
    restoreScrollPosition,
    scrollToBottom,
    isInitialLoad,
  ]);

  const { ref: topObserverRef, inView: topInView } = useInView({
    threshold: 0.1,
    rootMargin: "50px",
    skip: !hasNextPage || isFetchingNextPage || loadingRef.current,
  });

  const loadMoreMessages = useCallback(async () => {
    if (loadingRef.current || !hasNextPage || isFetchingNextPage) {
      return;
    }

    storeScrollPosition();

    loadingRef.current = true;
    setIsLoadingMore(true);

    try {
      await fetchNextPage();
    } catch (error) {
      console.error("Error loading more messages:", error);
    } finally {
      setTimeout(() => {
        loadingRef.current = false;
        setIsLoadingMore(false);
      }, 500);
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage, storeScrollPosition]);

  useEffect(() => {
    if (
      topInView &&
      hasNextPage &&
      !isFetchingNextPage &&
      !loadingRef.current &&
      initialLoadCompleteRef.current
    ) {
      loadMoreMessages();
    }
  }, [topInView, hasNextPage, isFetchingNextPage, loadMoreMessages]);

  useEffect(() => {
    loadingRef.current = false;
    setIsLoadingMore(false);
    scrollPositionRef.current = 0;
    previousMessagesLengthRef.current = 0;
    isScrollingProgrammaticallyRef.current = false;
    initialLoadCompleteRef.current = false;
    setIsInitialLoad(true);
  }, [selectedUser?.chat_unique]);

  useEffect(() => {
    if (
      !chatViewRef.current ||
      isScrollingProgrammaticallyRef.current ||
      !initialLoadCompleteRef.current ||
      isInitialLoad
    ) {
      return;
    }

    const chatContainer = chatViewRef.current;
    const isNearBottom =
      chatContainer.scrollHeight -
        chatContainer.scrollTop -
        chatContainer.clientHeight <
      100;

    if (isNearBottom) {
      isScrollingProgrammaticallyRef.current = true;
      chatContainer.scrollTop = chatContainer.scrollHeight;

      setTimeout(() => {
        isScrollingProgrammaticallyRef.current = false;
      }, 100);
    }
  }, [combinedMessages.length, isInitialLoad]);
  console.log("combinedMessages", combinedMessages);

  return (
    <>
      <ChatLayout
        sidebar={<SideBar onWorkspaceUpdate={handleWorkspaceUpdate} />}
        chatPannel={
          <DmsPannel
            directMessages={directMessages}
            loading={loading}
            onSelectedConversation={onSelectConversation}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        }
        mainContent={
          <div className={styles.ChatPageMainContent}>
            <div className={styles.ChatPageMainContentSub}>
              {selectedUser ? (
                <>
                  <ChatHeader
                    userName={userName}
                    userImage={userImage}
                    status={onlineStatus}
                    typing={typing}
                    onHeaderClick={handleHeaderClick}
                    type={selectedUser?.is_group_chat}
                    onSearch={handleSearch}
                    searchQuery={searchQuery}
                    pageFrom={"dms"}
                    onPinHeaderClick={handleHeaderPinClick}
                    isPinned={isConversationPinned}
                  />
                  <div className={styles.ChatPageMessageInput}>
                    <ChatView
                      messages={combinedMessages}
                      chatViewRef={chatViewRef}
                      isLoading={loadingConv}
                      height={height}
                      newReaction={reactions}
                      pendingMessages={pendingMessages}
                      chat_unique={selectedUser?.chat_unique}
                      typing={typing}
                      topObserverRef={topObserverRef}
                      isFetchingNextPage={isFetchingNextPage || isLoadingMore}
                      hasNextPage={hasNextPage}
                      onScrollPositionChange={storeScrollPosition}
                      onForwardClick={handleForwardClick}
                      onDeleteClick={handleDeleteClick}
                      onPinClick={handlePinClick}
                    />
                    {renderChatInput()}
                  </div>
                </>
              ) : (
                <>
                  <NoConvFound />
                </>
              )}
            </div>
          </div>
        }
      />
      {showPersonPopUp && (
        <PersonQuickView
          userId={userId}
          onClose={() => setShowPersonPopUp(false)}
        />
      )}
      {showGroupPopup && (
        <ViewGroupPopUp
          onClose={() => setShowGroupPopup(false)}
          groupId={groupId}
          updated={handleUpdated}
        />
      )}
      {showForword && selectedMessage && (
        <ChatForward
          onClose={handleCloseForward}
          messageId={selectedMessage.messageId}
          chatUniqueId={selectedMessage.chatUniqueId}
          pageFrom={"dms"}
          handleForward={handleForward}
        />
      )}
      {showDelete && selectedMessageDel && (
        <DeletionMsgConfirm
          onClose={handleCloseDelete}
          messageId={selectedMessageDel.messageId}
          chatUniqueId={selectedMessageDel.chatUniqueId}
          pageFrom={"home"}
          handleDeleteMessage={handleDeleteMessage}
        />
      )}
    </>
  );
};

export default DMs;
